module.exports = __webpack_public_path__ + "img/2024-19.0ec24282.jpg";